var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiSparkle = function SvgAiSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    fill: "none",
    viewBox: "0 0 11 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#686879",
    d: "M4.97 4.392a1.5 1.5 0 0 0 .885.886L7.807 6l-1.952.722a1.5 1.5 0 0 0-.885.886l-.723 1.95-.722-1.95a1.5 1.5 0 0 0-.885-.886L.687 6l1.953-.722a1.5 1.5 0 0 0 .885-.886l.722-1.952zm3.533-2.925c.089.28.31.5.59.59l.314.1-.313.099a.91.91 0 0 0-.591.59l-.1.313-.1-.313a.9.9 0 0 0-.59-.59l-.314-.1.315-.1c.28-.088.5-.309.59-.59l.1-.314z"
  })));
};
export default SvgAiSparkle;